import { memo } from 'react';

import { DeleteFilled } from '@ant-design/icons';
import { Button } from 'antd';

function RemoveGroupComponent({ handleOnClick }) {
  return (
    <Button type="text" icon={<DeleteFilled className="text-primary" />} title="Delete rule" onClick={handleOnClick} />
  );
}

export default memo(RemoveGroupComponent);
